import React from 'react';
import { Popover } from 'baseui/popover';
import { IDummyProps } from './typesStateless';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export const _UncontrolledPopover = (props: Omit<IDummyProps, 'isOpen'> & { onChange?: any, anchorProps?: any }, ref: any) => {
    const { showArrow = true, anchorProps, overrides, triggerType, ...rest } = props;
    const [_isOpen, setIsOpen] = React.useState<boolean>(false);
    const spanRef = React.useRef<any>(null);

    const _hoverable = props.triggerType == "hover" ? {
        onMouseEnter: () => { props.onChange && props.onChange(true); setIsOpen(true) },
        onMouseLeave: () => { props.onChange && props.onChange(false); setIsOpen(false) }
    } : {}

    return (
        <span ref={spanRef}>
            <Popover
                isOpen={_isOpen}
                ref={ref}
                showArrow={showArrow}
                triggerType={triggerType}
                onClickOutside={() => {
                    props.onChange && props.onChange(false)
                    setIsOpen(false)
                }}
                onClick={() => {
                    props.onChange && props.onChange(!_isOpen)
                    setIsOpen(!_isOpen);
                    console.log(_hoverable)
                }}
                onEsc={() => {
                    props.onChange && props.onChange(false)
                    setIsOpen(false);
                }}

                mountNode={spanRef.current}
                className="manu-test"
                overrides={overrides ? mergeOverrides(customOverrides(props), overrides) : customOverrides(props)}
                {...rest}
            >
                <div {..._hoverable} {...anchorProps}>
                    {props.children}
                </div>
            </Popover>
        </span>
    );
};

export const UncontrolledPopover = React.forwardRef(_UncontrolledPopover);